import { alertsApi } from '#entities';

import type { AppDispatch } from '#shared';

/**
 * Fetches the whole alert snapshot and replaces the cached active set.
 *
 * Called on connect, on every reconnect, and on a slow periodic tick — the three
 * client obligations BE ARCH-010 records against at-most-once delivery, where a
 * publish that fails after commit is never retried and the client heals here or
 * nowhere.
 *
 * Deliberately NOT modelled on `runDomainEventCatchup`: there is no sequence
 * cursor, no `?sinceSeq=` paging and no page cap, because `AlertFrame` carries
 * no seq and the snapshot is current truth rather than a delta (377:E027, E032).
 *
 * A 503 is the documented answer when the backend stream is disabled — "a
 * disabled stream must fail loudly, not answer 'no alerts'" — so the rejection
 * is left in the query cache for the page to render as unavailable, and is not
 * reported as contract drift (377:E026). Best-effort: never throws.
 */
export const runAlertSnapshot = async (
  dispatch: AppDispatch,
): Promise<void> => {
  try {
    await dispatch(
      alertsApi.endpoints.getAlerts.initiate(undefined, {
        subscribe: false,
        forceRefetch: true,
      }),
    ).unwrap();
  } catch {
    // The rejection is already in the RTK Query cache, which is what the page
    // reads. Catching here only stops it escaping into `socket.onopen`.
  }
};
